import React, { useState, useMemo, useEffect } from 'react';
import {Menu, Search, Loader2, Plus, X, Calculator, UserPlus , Receipt , LogOut, Wallet , Download} from 'lucide-react';

import { useNavigate } from 'react-router-dom';
import {PROJETOS_TABELA_NORMAL,} from "../constants/projetos";
import * as XLSX from 'xlsx';
import {  getDadosSalariosNydhus} from '../api';

const SimuladorDefinitivo = () => {
    const navigate = useNavigate();
  
  const [colaboradores, setColaboradores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [filterCargo, setFilterCargo] = useState('');
  const [filterModalidade, setFilterModalidade] = useState('');
  const [filterStatus, setFilterStatus] = useState('Ativo');
  const [mostrarModalFuncionario, setmostrarModalFuncionario] = useState(false);
  const [mostrarModalDetalhamento, setmostrarModalDetalhamento] = useState(false);
  const [open, setOpen] = useState(false);

    const mesesNome = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'];

  const [novoFuncionario, setNovoFuncionario] = useState({
    nome: '', cargo: '', salarioBase: '', modalidade: 'CLT',
    r1_agrup: '100%', r1_enq: null, r1_mes: mesesNome[new Date().getMonth()],
    r2_agrup: '100%', r2_enq: null, r2_mes: mesesNome[new Date().getMonth()],
    vigInicio: mesesNome[new Date().getMonth()], vigFim: 'Dezembro'
  });

  const [modificacoes, setModificacoes] = useState(new Map());
  const [filtroProjetos, setFiltroProjetos] = useState([]);
  const [menuProjetosAberto, setMenuProjetosAberto] = useState(false);

  // Retornado pelo backend com base nas abas existentes na planilha
  const [mesesRealizados, setMesesRealizados] = useState([]);

  
  // Mês atual (0-indexed). Meses anteriores ao atual ficam bloqueados para simulação.
  const MES_ATUAL_IDX = new Date().getMonth();
  const MES_ATUAL_NOME = mesesNome[MES_ATUAL_IDX];
  // Apenas meses iguais ou posteriores ao mês atual podem ser selecionados em simulações
  const mesesPermitidos = mesesNome.filter((_, idx) => idx >= MES_ATUAL_IDX);

  const agrupamentos = ['80%', '85%', '90%', '95%', '100%', '105%', '110%', '115%', '120%'];
  
  // Opção "-" mapeada para null, e "0" como número 0 real
  const enquadramentos = [{ value: null, label: '-' }, ...Array.from({ length: 15 }, (_, i) => ({ value: i, label: i.toString() }))];

  // TABELA DE REAJUSTE (Simplificada para o exemplo, mantenha a sua completa)
  const TABELA_REAJUSTE = {
    '80%': [1595, 1595, 1851, 2323, 2915, 3657, 4589, 5757, 7224, 9064, 11372, 14268, 17902, 22462, 28183],
    '85%': [1595, 1595, 1967, 2469, 3097, 3886, 4876, 6117, 7676, 9630, 12083, 15160, 19021, 23865, 29944],
    '90%': [1595, 1595, 2083, 2614, 3279, 4115, 5163, 6477, 8127, 10197, 12793, 16052, 20140, 25269, 31706],
    '95%': [1575, 1753, 2198, 2759, 3461, 4343, 5449, 6837, 8579, 10763, 13504, 16944, 21259, 26673, 33467],
    '100%': [1658, 1845, 2314, 2904, 3644, 4572, 5736, 7197, 9030, 11330, 14215, 17835, 22378, 28077, 35229],
    '105%': [1741, 1937, 2430, 3050, 3826, 4800, 6023, 7557, 9482, 11896, 14926, 18727, 23496, 29481, 36990],
    '110%': [1824, 2029, 2546, 3195, 4008, 5029, 6310, 7916, 9933, 12462, 15636, 19619, 24615, 30885, 38751],
    '115%': [1907, 2122, 2661, 3340, 4190, 5257, 6597, 8276, 10385, 13029, 16347, 20511, 25734, 32289, 40513],
    '120%': [1990, 2214, 2777, 3485, 4372, 5486, 6883, 8636, 10836, 13595, 17058, 21402, 26853, 33692, 42274]
  };
  const columns = Object.keys(TABELA_REAJUSTE);
  const rows = Array.from({ length: 15 }, (_, i) => i);
  const getDataAtualizacao = () => {
    const agora = new Date();

    const horaAtual = agora.getHours();

    if (horaAtual < 12) {
      agora.setDate(agora.getDate() - 1);
    }

    // Formatar data no padrão brasileiro
    const dataFormatada = agora.toLocaleDateString('pt-BR');

    return `${dataFormatada} - 12:00`;
};



  const BENEFICIOS_FIXOS = {
    'CLT': { Flash: 750, Clude: 3.68, Gympass: 14.60, 'Seguro de Vida': 3.91, Odonto: 15.84, Unimed: 180, Mobilidade: 100, 'Previdência': 100 },
    'PJ': { Flash: 750, Clude: 3.68, Gympass: 14.60, 'Seguro de Vida': 3.91, Odonto: 15.84, Unimed: 180, Mobilidade: 100, 'Previdência': 100 },
    'Estagiário': { Gympass: 14.60, Clude: 3.68, 'Seguro de Vida': 4.38, Mobilidade: 100 }
  };

  const calcularEncargosCLT = (salarioBase) => {
    const B1 = salarioBase;
    const B2 = B1 * 0.02;
    const B3 = B2 * 0.3636;
    const B4 = (B1 + B2 + B3) / 12;
    const B5 = (B1 + B2 + B3) / 12 * 0.3333;
    const base = B1 + B2 + B3 + B4 + B5;
    return B2 + B3 + B4 + B5 + (base * 0.20) + (base * 0.035) + (base * 0.058) + (base * 0.08) + (base * 0.04);
  };
const projetosOrdenados = useMemo(() => {
  return [...PROJETOS_TABELA_NORMAL].sort((a, b) => a.localeCompare(b));
}, []);

useEffect(() => {
  const fetchDados = async () => {
    try {
      setLoading(true);
      const resultado = await getDadosSalariosNydhus();
      if (resultado.success) {
        // Backend retorna quais meses já têm aba de realizado
        if (Array.isArray(resultado.meses_realizados)) {
          setMesesRealizados(resultado.meses_realizados);
        }

        const dados = resultado.data
          .filter(c => c['Setor Descrição']?.toUpperCase().includes('OPERAÇÃO'))
          .map((c, index) => {
            const tipo = c['Tipo Remuneração'] || '';
            let modalidade = 'CLT';

            if (tipo.includes('Prestação')) modalidade = 'PJ';
            else if (tipo.includes('Bolsa Auxílio')) modalidade = 'Estagiário';

            // Normaliza salarios_por_mes (snake_case do backend → camelCase do frontend)
            const salariosPorMes = c.salarios_por_mes
              ? Object.fromEntries(
                  Object.entries(c.salarios_por_mes).map(([mes, val]) => [mes, Number(val) || 0])
                )
              : null;

            return {
              ...c,
              tempId: index,
              // salarioBase = valor da aba padrão (Consulta Ativos) — usado como fallback
              salarioBase: Number(c['Salário - Último Valor']) || 0,
              // salariosPorMes = valor correto de cada mês (realizado ou projetado)
              salariosPorMes,
              projetos: [],
              Demissao: c['Demissão'] || null,
              mod_atual: modalidade,
              r1_mod: modalidade,
              r1_agrup: '100%', r1_enq: null, r1_mes: mesesNome[new Date().getMonth()],
              r2_mod: modalidade,
              r2_agrup: '100%', r2_enq: null, r2_mes: mesesNome[new Date().getMonth()],

              vig_inicio: 'Janeiro',
              vig_fim: 'Dezembro'
            };
          });
        setColaboradores(dados);
      }
    } catch (err) { console.error(err); } 
    finally { setLoading(false); }
  };
  fetchDados();
}, []);


  const handleEdit = (id, field, value) => {
    setColaboradores(prev => prev.map(c => c.tempId === id ? { ...c, [field]: value } : c));
    setModificacoes(prev => {
      const newMap = new Map(prev);
      const current = newMap.get(id);
      if (current !== 'novo') {
        newMap.set(id, 'editado');
      }
      return newMap;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const temSalario = Number(novoFuncionario.salarioBase) > 0;
    const temSimulacao = novoFuncionario.r1_enq !== null;

    if (!temSalario && !temSimulacao) {
      alert('Preencha o Salário Atual ou configure a Simulação Primária (Agrupador + Enquadramento).');
      return;
    }

    const novoId = Date.now();
    const funcionario = {
      tempId: novoId,
      Nome: novoFuncionario.nome,
      'Cargo Atual': novoFuncionario.cargo,
      'Setor Descrição': 'OPERAÇÃO',
      Status: 'Ativo',
      salarioBase: Number(novoFuncionario.salarioBase),
      isNovo: true, // Flag: salário base puro → encargos/benefícios devem ser calculados
      mod_atual: novoFuncionario.modalidade,
      r1_mod: novoFuncionario.modalidade, 
      r1_agrup: novoFuncionario.r1_agrup, 
      r1_enq: novoFuncionario.r1_enq, 
      r1_mes: novoFuncionario.r1_mes,
      r2_mod: novoFuncionario.modalidade, 
      r2_agrup: novoFuncionario.r2_agrup, 
      r2_enq: novoFuncionario.r2_enq, 
      r2_mes: novoFuncionario.r2_mes,
      vig_inicio: novoFuncionario.vigInicio, 
      vig_fim: novoFuncionario.vigFim,
      projetos: []
    };
    setColaboradores([funcionario, ...colaboradores]);
    setModificacoes(prev => {
      const newMap = new Map(prev);
      newMap.set(novoId, 'novo');
      return newMap;
    });
    setNovoFuncionario({
      nome: '', cargo: '', salarioBase: '', modalidade: 'CLT',
      r1_agrup: '100%', r1_enq: null, r1_mes: mesesNome[new Date().getMonth()],
      r2_agrup: '100%', r2_enq: null, r2_mes: mesesNome[new Date().getMonth()],
      vigInicio: mesesNome[new Date().getMonth()], vigFim: 'Dezembro'
    });
    setmostrarModalFuncionario(false);
  };

  const getRowClasses = (tempId) => {
    const tipo = modificacoes.get(tempId);

    if (tipo === 'novo') {
      return 'bg-green-200 hover:bg-green-300';
    }

    if (tipo === 'editado') {
      return 'bg-amber-200 hover:bg-amber-300 border-l-4 border-amber-600';
    }

    return 'hover:bg-slate-100';
  };


  const calcularCustoMes = (colab, mesIdx) => {
    let demissao = null;
    if (colab.Demissao) {
      const [dia, mes, ano] = colab.Demissao.split('/');
      demissao = new Date(`${ano}-${mes}-${dia}`);
    }
    if (demissao && demissao < new Date('2026-01-01')) return 0;
    if (demissao && demissao.getFullYear() === 2026) {
      const mesDemissao = demissao.getMonth();
      if (mesIdx > mesDemissao) return 0;
    }

    const inicioIdx = mesesNome.indexOf(colab.vig_inicio);
    const fimIdx = mesesNome.indexOf(colab.vig_fim);
    if (mesIdx < inicioIdx || mesIdx > fimIdx) return 0;

    const mesNome = mesesNome[mesIdx];

    // ── MESES REALIZADOS ──────────────────────────────────────────────────────
    // Para meses com aba de realizado (ex: "Consulta Ativos (Janeiro)"),
    // usamos diretamente o valor da planilha — já inclui encargos e benefícios.
    // Simulações não se aplicam a meses fechados.
    if (mesesRealizados.includes(mesNome) && !colab.isNovo) {
      const salarioRealizado = colab.salariosPorMes?.[mesNome] ?? colab.salarioBase;
      return salarioRealizado;
    }

    // ── MESES FUTUROS / PROJETADOS ────────────────────────────────────────────
    // Usa o valor da aba "Consulta Ativos" como base, aplicando simulações se configuradas.

    // salarioBase = valor da aba "Consulta Ativos" (projeção esperada)
    // salariosPorMes[mesNome] pode ter o mesmo valor, mas usamos salarioBase como fallback
    let salario = colab.salariosPorMes?.[mesNome] ?? colab.salarioBase;
    let modalidade = colab.mod_atual;

    // Flag: só soma encargos+benefícios quando o valor é salário base puro.
    // → isNovo: colaborador criado manualmente (sem histórico na planilha).
    // → simulação ativa: valor vem da tabela de reajuste, também é base puro.
    // Colaboradores normais da planilha já trazem o custo total realizado.
    let deveSomarEncargos = colab.isNovo === true;

    const checkSim = (enq, agrup, mes, mod) => {
      if (enq !== null && mesIdx >= mesesNome.indexOf(mes)) {
        const val = TABELA_REAJUSTE[agrup]?.[enq];
        if (val) { salario = val; modalidade = mod; deveSomarEncargos = true; return true; }
      }
      return false;
    };

    if (!checkSim(colab.r2_enq, colab.r2_agrup, colab.r2_mes, colab.r2_mod)) {
      checkSim(colab.r1_enq, colab.r1_agrup, colab.r1_mes, colab.r1_mod);
    }

    if (deveSomarEncargos) {
      const encargos = modalidade === 'CLT' ? calcularEncargosCLT(salario) : (modalidade === 'Estagiário' ? salario * 0.083 : 0);
      const beneficios = Object.values(BENEFICIOS_FIXOS[modalidade] || {}).reduce((a, b) => a + b, 0);
      return salario + encargos + beneficios;
    }

    // Planilha de projetado: valor já inclui encargos e benefícios
    return salario;
  };
  const orcamentoInicial = [
  2690248.08, 1243300.01, 1115584.47, 919798.54, 974292.85, 941942.51, 
  916775.65, 901695.68, 901695.68, 915296.17, 915296.17, 907800.75
];
  const faturamentoInicial = [
   2548431.45,	3851985.34,	3445293.21,	5486517.53,	5750134.74,	6164341.13,	5020014.21,	5492197.77,	5467359.73,	
   5588296.84,	5465053.62,	5720374.43
];

  const faturamentoInicialProjetado = [
   4292874, 0 ,0, 0,0,0,0,0,0,0,0,0
];

const [orcamento, setOrcamento] = useState(orcamentoInicial);
const [faturamento, setFaturamento] = useState(faturamentoInicial);

const [faturamentoProjetado, setFaturamentoProjetado] = useState(faturamentoInicialProjetado);



const totalGeralOrcamento = orcamento.reduce((a, b) => a + b, 0);
const totalGeralFaturamento = faturamento.reduce((a, b) => a + b, 0);

const totalGeralFaturamentoProjetado = faturamentoProjetado.reduce((a, b) => a + b, 0);



const handleEditOrcamento = (idx, value) => {
  const novoOrcamento = [...orcamento];
  novoOrcamento[idx] = parseFloat(value) || 0;
  setOrcamento(novoOrcamento);
};

const handleEditFaturamento = (idx, value) => {
  const novoFaturamento = [...faturamento];
  novoFaturamento[idx] = parseFloat(value) || 0;
  setFaturamento(novoFaturamento);
};

const handleEditFaturamentoProjetado = (idx, value) => {
  const novoFaturamentoProjetado = [...faturamentoProjetado];
  novoFaturamentoProjetado[idx] = parseFloat(value) || 0;
  setFaturamentoProjetado(novoFaturamentoProjetado);
};

const formatCurrency = (value) => {
  return new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL',
  }).format(value);
};

// const atualizarProjeto = (tempId, projeto) => {
//   setColaboradores((prev) =>
//     prev.map((f) =>
//       f.tempId === tempId // Correção: Usar tempId em vez de id
//         ? { ...f, projeto }
//         : f
//     )
//   );
  
//   // Opcional: Marcar como editado para o sistema de cores
//   setModificacoes(prev => {
//     const newMap = new Map(prev);
//     if (newMap.get(tempId) !== 'novo') {
//       newMap.set(tempId, 'editado');
//     }
//     return newMap;
//   });
// };

const adicionarProjeto = (tempId, novoProjeto) => {
  if (!novoProjeto) return;
  
  setColaboradores(prev => prev.map(c => {
    if (c.tempId === tempId) {
      // Evita duplicados
      if (c.projetos.includes(novoProjeto)) return c;
      return { ...c, projetos: [...c.projetos, novoProjeto] };
    }
    return c;
  }));
  
  // Marca como editado (opcional, mantendo sua lógica visual)
  setModificacoes(prev => new Map(prev).set(tempId, 'editado'));
};

const removerProjeto = (tempId, projetoParaRemover) => {
  setColaboradores(prev => prev.map(c => {
    if (c.tempId === tempId) {
      return { ...c, projetos: c.projetos.filter(p => p !== projetoParaRemover) };
    }
    return c;
  }));
  setModificacoes(prev => new Map(prev).set(tempId, 'editado'));
};

const filtrados = useMemo(() => {
  return colaboradores.filter(c => 
    c.Nome?.toLowerCase().includes(searchTerm.toLowerCase()) &&
    (!filterCargo || c['Cargo Atual'] === filterCargo) &&
    (!filterModalidade || c.mod_atual === filterModalidade) &&
    (!filterStatus || c.Status === filterStatus) &&
    // LÓGICA DO MULTI-FILTRO DE PROJETOS:
    (filtroProjetos.length === 0 || c.projetos.some(p => filtroProjetos.includes(p)))
  );
}, [colaboradores, searchTerm, filterCargo, filterModalidade, filterStatus, filtroProjetos]);

// Cálculos automáticos baseados nos colaboradores FILTRADOS — reage a qualquer filtro ativo
const totaisMensais = useMemo(() => {
  return mesesNome.map((_, idx) =>
    filtrados.reduce((acc, colab) => acc + calcularCustoMes(colab, idx), 0)
  );
}, [filtrados, mesesRealizados]);

const totalGeralColaboradores = totaisMensais.reduce((a, b) => a + b, 0);

const exportarParaExcel = () => {
  const dadosFormatados = filtrados.map(colab => {
    const linha = {
      "Nome": colab.Nome,
      "Cargo": colab['Cargo Atual'],
      "Modalidade": colab.mod_atual || '-',
      "Status": colab.Status,
      "Salário Base": colab.salarioBase,
      
      "Projetos": colab.projetos ? colab.projetos.join(", ") : "", 
      
      // Dados da Simulação (Regra 1)
      "R1 - Agrupador": colab.r1_agrup,
      "R1 - Enquadramento": colab.r1_enq ? `${colab.r1_enq}%` : '-',
      "R1 - Mês": colab.r1_mes,
      
      // Dados da Simulação (Regra 2)
      "R2 - Agrupador": colab.r2_agrup,
      "R2 - Enquadramento": colab.r2_enq ? `${colab.r2_enq}%` : '-',
      "R2 - Mês": colab.r2_mes,
    };

    // Adicionar valores mensais
    let totalAnual = 0;
    mesesNome.forEach((mes, idx) => {
      const custoMes = calcularCustoMes(colab, idx);
      linha[mes] = custoMes;
      totalAnual += custoMes;
    });

    // Adicionar total anual
    linha["Total Anual"] = totalAnual;

    return linha;
  });

  // Criar a planilha (Worksheet)
  const worksheet = XLSX.utils.json_to_sheet(dadosFormatados);


  // Criar o arquivo (Workbook) e adicionar a planilha
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Simulação Folha");

  // 5. Gerar o arquivo e baixar
  XLSX.writeFile(workbook, "Relatorio_Simulacao.xlsx");
};
  if (loading) return <div className="h-screen flex items-center justify-center"><Loader2 className="animate-spin text-purple-600" /></div>;


  return (
    <div className="w-full bg-slate-50 h-screen flex flex-col overflow-hidden">
      
      {/* HEADER GRADIENTE */}
      <header className="bg-gradient-to-r from-indigo-900 via-purple-900 to-pink-800 text-white px-8 py-4 flex justify-between items-center shadow-lg shrink-0">
        <div>
          <h1 className="text-xl font-bold">Simulador Financeiro 2026</h1>
          <h1 className="text-purple-200 text-[10px] uppercase tracking-wider">Atualizado em {getDataAtualizacao()}</h1>

        </div>
        
        <div className="relative flex items-center space-x-3">
          {/* Botão Hamburger */}

              <button onClick={() => setmostrarModalFuncionario(true)} className="bg-white/10 hover:bg-white/20 px-6 py-2 rounded-full flex items-center gap-2 border border-white/30 transition-all font-bold text-sm">
                <Plus className="w-4 h-4" /> Novo Funcionário
              </button>

              <button  onClick={() => setmostrarModalDetalhamento(true)} 
                className="bg-white/10 hover:bg-white/20 px-6 py-2 rounded-full flex items-center gap-2 border border-white/30 transition-all font-bold text-sm">
                <Calculator className="w-4 h-4" /> Tabela de Reajuste
              </button>

              <button
                onClick={() => {
                  navigate('/inicio');
                }}
                className="flex items-center gap-2 px-4 py-2 hover:bg-white/10 rounded-lg text-sm font-bold"
              >
                    Menu Principal
              </button>         

        </div>
      </header>

      {/* FILTROS RESTAURADOS E MELHORADOS */}
      <div className="px-8 py-3 bg-white border-b flex flex-wrap gap-4 items-center shadow-sm z-10">
        <div className="relative w-64">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-slate-400" />
          <input className="w-full pl-10 pr-4 py-1.5 bg-slate-100 border-none rounded-lg text-xs" placeholder="Buscar..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} />
        </div>
        
        <select className="bg-slate-100 border-none rounded-lg text-[11px] px-3 py-1.5 outline-none focus:ring-1 focus:ring-purple-500" value={filterStatus} onChange={e => setFilterStatus(e.target.value)}>
          <option value="">Status: Todos</option>
          <option value="Ativo">Ativo</option>
          <option value="Inativo">Inativo</option>
        </select>

        <select className="bg-slate-100 border-none rounded-lg text-[11px] px-3 py-1.5 outline-none focus:ring-1 focus:ring-purple-500" value={filterModalidade} onChange={e => setFilterModalidade(e.target.value)}>
          <option value="">Modalidade: Todas</option>
          <option value="CLT">CLT</option>
          <option value="PJ">PJ</option>
          <option value="Estagiário">Estagiário</option>
        </select>

        <select className="bg-slate-100 border-none rounded-lg text-[11px] px-3 py-1.5 outline-none focus:ring-1 focus:ring-purple-500" value={filterCargo} onChange={e => setFilterCargo(e.target.value)}>
          <option value="">Cargo: Todos</option>
          {[...new Set(colaboradores.map(c => c['Cargo Atual']))].sort().map(cargo => <option key={cargo} value={cargo}>{cargo}</option>)}
        </select>

        {/* Dropdown Multi-Select de Filtro de Projetos */}
        <div className="relative">
          <button 
            onClick={() => setMenuProjetosAberto(!menuProjetosAberto)}
            className="bg-slate-100 border border-transparent hover:border-slate-300 rounded-lg text-[11px] px-3 py-1.5 outline-none flex items-center gap-2 text-slate-700 font-medium"
          >
            {filtroProjetos.length === 0 ? 'Todos os Projetos' : `${filtroProjetos.length} selecionados`}
            <span className="text-[9px]">▼</span>
          </button>

          {menuProjetosAberto && (
            <>
              <div className="fixed inset-0 z-40" onClick={() => setMenuProjetosAberto(false)}></div>
              <div className="absolute top-full left-0 mt-1 w-64 bg-white border border-slate-200 rounded-xl shadow-xl z-50 p-2 max-h-60 overflow-y-auto">
                <div className="text-[10px] uppercase font-bold text-slate-400 px-2 mb-2">Filtrar por Projetos</div>
                {projetosOrdenados.map(proj => (
                  <label key={proj} className="flex items-center gap-2 px-2 py-1.5 hover:bg-slate-50 rounded cursor-pointer text-xs">
                    <input 
                      type="checkbox"
                      checked={filtroProjetos.includes(proj)}
                      onChange={(e) => {
                        if (e.target.checked) {
                          setFiltroProjetos([...filtroProjetos, proj]);
                        } else {
                          setFiltroProjetos(filtroProjetos.filter(p => p !== proj));
                        }
                      }}
                      className="rounded border-slate-300 text-purple-600 focus:ring-purple-500"
                    />
                    <span className="text-slate-700">{proj}</span>
                  </label>
                ))}
                {filtroProjetos.length > 0 && (
                  <button 
                    onClick={() => setFiltroProjetos([])}
                    className="w-full text-center text-[10px] text-red-500 font-bold mt-2 hover:bg-red-50 p-1 rounded"
                  >
                    Limpar Filtros
                  </button>
                )}
              </div>
            </>
          )}
        </div>

        <div className="ml-auto text-[11px] font-bold text-indigo-600 bg-indigo-50 px-3 py-1 rounded-full">
          Total: {filtrados.length} colaboradores
        </div>
          <button 
            onClick={exportarParaExcel}
            className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white text-xs font-bold rounded-lg shadow-sm transition-all"
            title="Exportar dados filtrados para Excel"
          >
            <Download className="w-4 h-4" />
            Exportar Arquivo
          </button>
        
      </div>
      {/* DASHBOARD DE MÉTRICAS */}
      <div className="px-8 py-4 bg-white border-b grid grid-cols-3 gap-6 shadow-sm">
        <div className="bg-slate-50 p-3 rounded-xl border border-slate-200">
          <p className="text-[10px] font-bold text-slate-500 uppercase">Faturamento Bruto Orçamento</p>
          <p className="text-lg font-black text-slate-800">
            {totalGeralFaturamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
          </p>
        </div>
        <div className="bg-slate-50 p-3 rounded-xl border border-slate-200">
          <p className="text-[10px] font-bold text-slate-500 uppercase">Orçamento Previsto</p>
          <p className="text-lg font-black text-slate-800">
            {totalGeralOrcamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
          </p>
        </div>
        <div className="bg-indigo-50 p-3 rounded-xl border border-indigo-100">
          <p className="text-[10px] font-bold text-indigo-500 uppercase">Total Real (Simulado)</p>
          <p className="text-lg font-black text-indigo-900">
            {totalGeralColaboradores.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
          </p>
        </div>
        <div className={`p-3 rounded-xl border ${totalGeralOrcamento - totalGeralColaboradores >= 0 ? 'bg-emerald-50 border-emerald-100' : 'bg-red-50 border-red-100'}`}>
          <p className="text-[10px] font-bold text-slate-500 uppercase">Delta</p>
          <p className={`text-lg font-black ${totalGeralOrcamento - totalGeralColaboradores >= 0 ? 'text-emerald-700' : 'text-red-700'}`}>
            {(totalGeralOrcamento - totalGeralColaboradores).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
          </p>
        </div>
          <div className="bg-slate-50 p-3 rounded-xl border border-slate-200">
          <p className="text-[10px] font-bold text-slate-500 uppercase">Orçado</p>
          <p className="text-lg font-black text-slate-800">
            {(totalGeralOrcamento/totalGeralFaturamento).toFixed(2)*100}%
          </p>
        </div>
          <div className="bg-slate-50 p-3 rounded-xl border border-slate-200">
          <p className="text-[10px] font-bold text-slate-500 uppercase">simulado</p>
          <p className="text-lg font-black text-slate-800">
            {((totalGeralColaboradores/totalGeralFaturamentoProjetado)*100).toFixed(2)}%
          </p>
        </div>
      </div>

      {/* CONTAINER COM SCROLL LATERAL GARANTIDO */}
      <div className="flex-1 overflow-auto p-4 bg-slate-200/50">
        <div className="bg-white rounded-xl shadow-sm border border-slate-200 inline-block min-w-full">
          <table className="min-w-[3200px] border-collapse text-[11px]">
            <thead>
              {/* Linha de Orçamento Editável */}              
              <tr className="bg-slate-50 border-b">
                <td className="sticky left-0 z-40 bg-slate-100 p-2 font-bold text-slate-600 border-r">Faturamento Bruto Orçamento</td>
                <td colspan="11" className="bg-slate-100 border-r"></td>
                {faturamento.map((val, idx) => (
                  <td key={idx} className="p-1 border-r">
                    <input
                      inputMode="numeric"
                      pattern="[0-9,.]*"
                      className="p-2 text-right font-mono font-bold text-black-600 border-r"
                      value={val.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      onChange={(e) => {
                        const raw = e.target.value.replace(/\./g, '').replace(',', '.');
                        handleEditFaturamento(idx, raw);
                      }}
                    />

                  </td>
                ))}
                <td className="sticky left-0 z-40 bg-slate-200 p-2 text-right font-bold text-slate-700">
                  {totalGeralFaturamento.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </td>
              </tr>

              <tr className="bg-slate-50 border-b">
                <td className="sticky left-0 z-40 bg-slate-100 p-2 font-bold text-slate-600 border-r">ORÇAMENTO (Editável)</td>
                <td colspan="11" className="bg-slate-100 border-r"></td>
                {orcamento.map((val, idx) => (
                  <td key={idx} className="p-1 border-r">
                    <input
                      inputMode="numeric"
                      pattern="[0-9,.]*"
                      className="p-2 text-right font-mono font-bold text-black-600 border-r"
                      value={val.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      onChange={(e) => {
                        const raw = e.target.value.replace(/\./g, '').replace(',', '.');
                        handleEditOrcamento(idx, raw);
                      }}
                    />

                  </td>
                ))}
                <td className="sticky left-0 z-40 bg-slate-200 p-2 text-right font-bold text-slate-700">
                  {totalGeralOrcamento.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </td>
              </tr>
               <tr className="bg-white border-b">
                <td className="sticky left-0 z-40 bg-white p-2 font-bold text-slate-500 border-r">% orçamento</td>
                <td colspan="11" className="border-r"></td>
                {mesesNome.map((_, idx) => {
                  const diff = ((orcamento[idx] / faturamento[idx])*100).toFixed(2);
                  return (
                    <td key={idx} className={`p-2 text-right font-mono font-bold border-r ${diff >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                      {diff.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}%
                    </td>
                  );
                })}
                <td className={`sticky left-0 z-40 bg-indigo-100 p-2 text-right font-bold text-indigo-800`}>
                  {((totalGeralOrcamento / totalGeralFaturamento)*100).toFixed(2)}%
                </td>
              </tr>
              <tr className="bg-slate-50 border-b">
                <td className="sticky left-0 z-40 bg-slate-100 p-2 font-bold text-slate-600 border-r">Faturamento Liquido Projetado</td>
                <td colspan="11" className="bg-slate-100 border-r"></td>
                {faturamentoProjetado.map((val, idx) => (
                  <td key={idx} className="p-1 border-r">
                    <input
                      inputMode="numeric"
                      pattern="[0-9,.]*"
                      className="p-2 text-right font-mono font-bold text-black-600 border-r"
                      value={val.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                      onChange={(e) => {
                        const raw = e.target.value.replace(/\./g, '').replace(',', '.');
                        handleEditFaturamentoProjetado(idx, raw);
                      }}
                    />

                  </td>
                ))}
                <td className="sticky left-0 z-40 bg-slate-200 p-2 text-right font-bold text-slate-700">
                  {totalGeralFaturamentoProjetado.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </td>
              </tr>
              {/* Linha de Total Real */}
              <tr className="bg-indigo-50/30 border-b">
                <td className="sticky left-0 z-40 bg-indigo-50 p-2 font-bold text-indigo-700 border-r">TOTAL SIMULADO</td>
                <td colspan="11" className="bg-indigo-50/30 border-r"></td>
                {totaisMensais.map((val, idx) => (
                  <td key={idx} className="p-2 text-right font-mono font-bold text-indigo-600 border-r">
                    {val.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                  </td>
                ))}
                <td className="sticky left-0 z-40 bg-indigo-100 p-2 text-right font-bold text-indigo-800">
                  {totalGeralColaboradores.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </td>
              </tr>
               <tr className="bg-white border-b">
                <td className="sticky left-0 z-40 bg-white p-2 font-bold text-slate-500 border-r">% Simulado</td>
                <td colspan="11" className="border-r"></td>
                {mesesNome.map((_, idx) => {
                  const diff = (totaisMensais[idx] / faturamentoProjetado[idx]).toFixed(2)*100;
                  return (
                    <td key={idx} className={`p-2 text-right font-mono font-bold border-r ${diff >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                      {diff.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}%
                    </td>
                  );
                })}
                <td className={`sticky left-0 z-40 bg-indigo-100 p-2 text-right font-bold text-indigo-800`}>
                  {((totalGeralColaboradores / totalGeralFaturamentoProjetado)*100).toFixed(2)}%
                </td>
              </tr>

              {/* Linha de Delta */}
              <tr className="bg-white border-b">
                <td className="sticky left-0 z-40 bg-white p-2 font-bold text-slate-500 border-r">DELTA (Orc - Real)</td>
                <td colSpan="11" className="border-r"></td>
                {mesesNome.map((_, idx) => {
                  const diff = orcamento[idx] - totaisMensais[idx];
                  return (
                    <td key={idx} className={`p-2 text-right font-mono font-bold border-r ${diff >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                      {diff.toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                    </td>
                  );
                })}
                <td className={`sticky left-0 z-40 p-2 text-right font-bold border-r ${(totalGeralOrcamento - totalGeralColaboradores) >= 0 ? 'bg-emerald-100 text-emerald-800' : 'bg-red-100 text-red-800'}`}>
                  {(totalGeralOrcamento - totalGeralColaboradores).toLocaleString('pt-BR', { minimumFractionDigits: 2 })}
                </td>
              </tr>

              <tr className="bg-slate-800 text-white">
                {/* Coluna 1: Começa no 0 */}
                <th className="sticky left-0 z-40 bg-slate-800 p-3 text-left w-[250px] border-r border-slate-700">
                  Funcionário
                </th>
                <th className="sticky left-[250px] bg-slate-800 p-3 text-left w-[500px] border-r border-slate-700">
                  Projeto
                </th>
                {/* Coluna 2 (Simulação 1): Precisa começar onde a primeira termina (250px) */}
                <th colSpan="4" className="sticky left-[250px] bg-slate-800 p-3 text-left w-[500px] border-r border-slate-700">
                  Primeiro Reajuste
                </th>

                {/* Restante das colunas (Não fixas) */}
                <th colSpan="4" className="sticky left-[500px] bg-slate-800 p-3 text-left w-[500px] border-r border-slate-700">Segundo Reajuste </th>
                <th colSpan="2" className="sticky left-[750px] bg-slate-800 p-3 text-left w-[500px] border-r border-slate-700">Vigência</th>
                
                {mesesNome.map(m => (
                  <th key={m} className="p-2 min-w-[140px] border-r border-slate-700">{m}</th>
                ))}

                {/* Custo Anual: Se quiser fixa à DIREITA, use right-0 */}
                <th className="sticky left-0 z-40 bg-emerald-700 p-3 w-[150px] shadow-l">
                  Custo Anual
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-slate-100">
              {filtrados.map(c => {
                let totalAcumulado = 0;
                const celulasMeses = mesesNome.map((_, idx) => {
                  const v = calcularCustoMes(c, idx);
                  totalAcumulado += v;
                  return v;
                });

                return (
                  <tr key={c.tempId} className={`group ${getRowClasses(c.tempId)}`}>
                    {/* COLUNA 1: Funcionário - Cor Sólida */}
                    <td className="sticky left-0 z-30 bg-white p-3 border-r border-slate-200 shadow-sm font-bold text-slate-700 w-[250px] min-w-[250px] group-hover:bg-slate-50">
                      <div className="truncate">{c.Nome}</div>
                      <div className="text-[9px] font-normal text-slate-400">{c['Cargo Atual']}</div>
                    </td>
                    {/* Célula de Múltiplos Projetos */}
                    <td className="sticky left-[250px] z-30 bg-white p-2 w-[200px] min-w-[200px] border-r border-slate-200 group-hover:bg-slate-50 align-top">
                      <div className="flex flex-wrap gap-1 mb-1">
                        {c.projetos && c.projetos.map(proj => (
                          <span key={proj} className="inline-flex items-center gap-1 px-1.5 py-0.5 rounded bg-indigo-50 text-indigo-700 border border-indigo-100 text-[9px] font-bold">
                            {proj}
                            <button 
                              onClick={() => removerProjeto(c.tempId, proj)}
                              className="hover:text-red-500 transition-colors"
                            >
                              <X className="w-3 h-3" />
                            </button>
                          </span>
                        ))}
                      </div>
                      
                      {/* Select camuflado de botão adicionar */}
                      <div className="relative group/add">
                        <div className="flex items-center gap-1 text-[10px] text-slate-400 group-hover/add:text-indigo-600 cursor-pointer">
                          <Plus className="w-3 h-3" /> Adicionar
                        </div>
                        <select 
                          className="absolute inset-0 opacity-0 cursor-pointer w-full"
                          value=""
                          onChange={(e) => adicionarProjeto(c.tempId, e.target.value)}
                        >
                          <option value="">Selecionar...</option>
                          {projetosOrdenados
                            .filter(p => !c.projetos.includes(p)) // Não mostra projetos que ele já tem
                            .map(p => (
                              <option key={p} value={p}>{p}</option>
                          ))}
                        </select>
                      </div>
                    </td>


                    {/* GRUPO PRIMEIRO REAJUSTE - Usando cores sólidas para não vazar conteúdo */}
                    <td className="sticky left-[250px] z-30 bg-[#f8fafc] p-1 w-[62.5px] min-w-[62.5px] group-hover:bg-indigo-50">
                      <select className="w-full border-none bg-transparent text-xs" value={c.r1_mod} onChange={e => handleEdit(c.tempId, 'r1_mod', e.target.value)}>
                        <option>CLT</option><option>PJ</option><option>Estagiário</option>
                      </select>
                    </td>
                    <td className="sticky left-[312.5px] z-30 bg-[#f8fafc] p-1 w-[62.5px] min-w-[62.5px] group-hover:bg-indigo-50">
                      <select className="w-full border-none bg-transparent text-xs" value={c.r1_agrup} onChange={e => handleEdit(c.tempId, 'r1_agrup', e.target.value)}>
                        {agrupamentos.map(a => <option key={a}>{a}</option>)}
                      </select>
                    </td>
                    <td className="sticky left-[375px] z-30 bg-[#f8fafc] p-1 w-[62.5px] min-w-[62.5px] group-hover:bg-indigo-50">
                      <select 
                        className="w-full border-none bg-transparent font-bold text-xs" 
                        value={c.r1_enq === null ? "" : c.r1_enq} 
                        onChange={e => handleEdit(c.tempId, 'r1_enq', e.target.value === "" ? null : parseInt(e.target.value))}
                      >
                        {enquadramentos.map(enq => <option key={String(enq.value)} value={enq.value === null ? "" : enq.value}>{enq.label}</option>)}
                      </select>
                    </td>
                    <td className="sticky left-[437.5px] z-30 bg-[#f8fafc] p-1 border-r border-slate-200 w-[62.5px] min-w-[62.5px] group-hover:bg-indigo-50">
                      <select className="w-full border-none bg-transparent text-xs" value={c.r1_mes} onChange={e => handleEdit(c.tempId, 'r1_mes', e.target.value)}>
                        {mesesNome.map((m, idx) => (
                          <option key={m} value={m} disabled={idx < MES_ATUAL_IDX}>{m}{idx < MES_ATUAL_IDX ? ' ✕' : ''}</option>
                        ))}
                      </select>
                    </td>

                    {/* GRUPO SIMULAÇÃO 2 - Usando cor sólida (ex: um roxo bem clarinho sólido) */}
                    <td className="sticky left-[500px] z-30 bg-[#faf5ff] p-1 w-[62.5px] min-w-[62.5px] group-hover:bg-purple-50">
                      <select className="w-full border-none bg-transparent text-xs" value={c.r2_mod} onChange={e => handleEdit(c.tempId, 'r2_mod', e.target.value)}>
                        <option>CLT</option><option>PJ</option><option>Estagiário</option>
                      </select>
                    </td>
                    <td className="sticky left-[562.5px] z-30 bg-[#faf5ff] p-1 w-[62.5px] min-w-[62.5px] group-hover:bg-purple-50">
                      <select className="w-full border-none bg-transparent text-xs" value={c.r2_agrup} onChange={e => handleEdit(c.tempId, 'r2_agrup', e.target.value)}>
                        {agrupamentos.map(a => <option key={a}>{a}</option>)}
                      </select>
                    </td>
                    <td className="sticky left-[625px] z-30 bg-[#faf5ff] p-1 w-[62.5px] min-w-[62.5px] group-hover:bg-purple-50">
                      <select 
                        className="w-full border-none bg-transparent font-bold text-xs" 
                        value={c.r2_enq === null ? "" : c.r2_enq} 
                        onChange={e => handleEdit(c.tempId, 'r2_enq', e.target.value === "" ? null : parseInt(e.target.value))}
                      >
                        {enquadramentos.map(enq => <option key={String(enq.value)} value={enq.value === null ? "" : enq.value}>{enq.label}</option>)}
                      </select>
                    </td>
                    <td className="sticky left-[687.5px] z-30 bg-[#faf5ff] p-1 border-r border-slate-200 w-[62.5px] min-w-[62.5px] group-hover:bg-purple-50">
                      <select className="w-full border-none bg-transparent text-xs" value={c.r2_mes} onChange={e => handleEdit(c.tempId, 'r2_mes', e.target.value)}>
                        {mesesNome.map((m, idx) => (
                          <option key={m} value={m} disabled={idx < MES_ATUAL_IDX}>{m}{idx < MES_ATUAL_IDX ? ' ✕' : ''}</option>
                        ))}
                      </select>
                    </td>

                    {/* VIGÊNCIA - Cor Sólida (bg-slate-50) */}
                    <td className="sticky left-[750px] z-30 bg-white p-1 w-[125px] min-w-[125px] border-r border-slate-200 group-hover:bg-slate-50">
                      <select className="w-full border-none bg-transparent text-xs" value={c.vig_inicio} onChange={e => handleEdit(c.tempId, 'vig_inicio', e.target.value)}>
                        {mesesNome.map(m => <option key={m}>{m}</option>)}
                      </select>
                    </td>
                    <td className="sticky left-[875px] z-30 bg-white p-1 w-[125px] min-w-[125px] border-r border-slate-200 group-hover:bg-slate-50">
                      <select className="w-full border-none bg-transparent text-xs" value={c.vig_fim} onChange={e => handleEdit(c.tempId, 'vig_fim', e.target.value)}>
                        {mesesNome.map(m => <option key={m}>{m}</option>)}
                      </select>
                    </td>

                    {/* MESES - Rolagem Lateral */}
                    {celulasMeses.map((v, idx) => (
                      <td key={idx} className="p-2 text-right font-mono text-slate-600 border-r border-slate-100 min-w-[140px]">
                        {v > 0 ? v.toLocaleString('pt-BR', { minimumFractionDigits: 2 }) : '-'}
                      </td>
                    ))}

                    {/* CUSTO ANUAL - Fixo na Direita */}
                    <td className="bg-emerald-50 p-3 text-right font-bold text-emerald-800 shadow-[-4px_0_8px_rgba(0,0,0,0.1)] group-hover:bg-emerald-100">
                      {totalAcumulado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      {/* MODAL COM FORMULÁRIO (CRIAR FUNCIONARIO) */}
      {mostrarModalFuncionario && (
        <div className="fixed inset-0 bg-slate-900/60 backdrop-blur-sm flex items-center justify-center z-[100] p-4">
          <form onSubmit={handleSubmit} className="bg-white rounded-[2rem] shadow-2xl w-full max-w-4xl overflow-hidden animate-in fade-in zoom-in duration-200 border border-white/20">
            
            {/* Header do Modal com o mesmo gradiente da tela principal */}
            <div className="bg-gradient-to-r from-indigo-900 via-purple-900 to-pink-800 px-8 py-6 text-white flex justify-between items-center">
              <div className="flex items-center gap-3">
                <div className="p-2 bg-white/10 rounded-lg"><UserPlus className="w-6 h-6" /></div>
                <div>
                  <h2 className="text-xl font-bold">Configurar Novo Registro</h2>
                  <p className="text-purple-200 text-[10px] uppercase font-bold tracking-widest">Preenchimento Completo da Folha</p>
                </div>
              </div>
              <button type="button" onClick={() => setmostrarModalFuncionario(false)} className="hover:rotate-90 transition-transform p-2 bg-black/20 rounded-full"><X className="w-5 h-5" /></button>
            </div>

            <div className="p-8 grid grid-cols-12 gap-8 max-h-[75vh] overflow-y-auto">
              
              {/* COLUNA 1: DADOS BÁSICOS */}
              <div className="col-span-12 lg:col-span-4 space-y-5">
                <h3 className="text-indigo-900 font-bold flex items-center gap-2 border-b pb-2 text-xs uppercase tracking-tighter">
                  <Calculator className="w-4 h-4" /> Informações Base
                </h3>
                <div className="space-y-4">
                  <div>
                    <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Nome Completo</label>
                    <input  type="text" className="w-full bg-slate-100 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500 transition-all" placeholder="Ex: João da Silva" value={novoFuncionario.nome} onChange={e => setNovoFuncionario({...novoFuncionario, nome: e.target.value})} />
                  </div>
                  <div>
                    <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Cargo na Operação</label>
                    <input  type="text" className="w-full bg-slate-100 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500" value={novoFuncionario.cargo} onChange={e => setNovoFuncionario({...novoFuncionario, cargo: e.target.value})} />
                  </div>
                  <div className="grid grid-cols-2 gap-3">
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">
                        Salário Atual
                        <span className="ml-1 text-indigo-400 normal-case font-normal">(ou preencha a Simulação Primária)</span>
                      </label>
                      <input type="number" step="0.01" className="w-full bg-slate-100 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500 font-mono" placeholder="0,00" value={novoFuncionario.salarioBase} onChange={e => setNovoFuncionario({...novoFuncionario, salarioBase: e.target.value})} />
                    </div>
                    <div>
                      <label className="block text-[10px] font-bold text-slate-400 uppercase mb-1">Contrato</label>
                      <select className="w-full bg-slate-100 border-none rounded-xl p-3 text-sm focus:ring-2 focus:ring-indigo-500 font-bold" value={novoFuncionario.modalidade} onChange={e => setNovoFuncionario({...novoFuncionario, modalidade: e.target.value, r1_mod: e.target.value, r2_mod: e.target.value})}>
                        <option>CLT</option><option>PJ</option><option>Estagiário</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* COLUNA 2: SIMULAÇÕES (PRÉ-PREENCHIMENTO) */}
              <div className="col-span-12 lg:col-span-8 bg-slate-50 p-6 rounded-3xl border border-slate-100 space-y-6">
                <h3 className="text-purple-900 font-bold flex items-center gap-2 border-b border-purple-100 pb-2 text-xs uppercase tracking-tighter">
                  <Calculator className="w-4 h-4" /> Planejamento de Reajustes
                </h3>
                
                <div className="grid grid-cols-2 gap-6">
                  {/* Simulação 1 */}
                  <div className="space-y-3 bg-white p-4 rounded-2xl shadow-sm border border-indigo-100">
                    <p className="text-[10px] font-black text-indigo-600 uppercase italic">Simulação A (Primária)</p>
                    <div className="grid grid-cols-2 gap-2">
                        <select className="text-[11px] p-2 bg-slate-50 border-none rounded-lg" value={novoFuncionario.r1_agrup} onChange={e => setNovoFuncionario({...novoFuncionario, r1_agrup: e.target.value})}>{agrupamentos.map(a => <option key={a}>{a}</option>)}</select>
                        <select className="text-[11px] p-2 bg-slate-50 border-none rounded-lg font-bold" value={novoFuncionario.r1_enq || ""} onChange={e => setNovoFuncionario({...novoFuncionario, r1_enq: e.target.value === "" ? null : parseInt(e.target.value)})}>
                           {enquadramentos.map(enq => <option key={String(enq.value)} value={enq.value === null ? "" : enq.value}>{enq.label}</option>)}
                        </select>
                    </div>
                    <select className="w-full text-[11px] p-2 bg-indigo-50 text-indigo-700 border-none rounded-lg font-bold" value={novoFuncionario.r1_mes} onChange={e => setNovoFuncionario({...novoFuncionario, r1_mes: e.target.value})}>
                        {mesesNome.map((m, idx) => (
                          <option key={m} value={m} disabled={idx < MES_ATUAL_IDX}>{m}{idx < MES_ATUAL_IDX ? ' ✕' : ''}</option>
                        ))}
                    </select>
                  </div>

                  {/* Simulação 2 */}
                  <div className="space-y-3 bg-white p-4 rounded-2xl shadow-sm border border-purple-100">
                    <p className="text-[10px] font-black text-purple-600 uppercase italic">Simulação B (Secundária)</p>
                    <div className="grid grid-cols-2 gap-2">
                        <select className="text-[11px] p-2 bg-slate-50 border-none rounded-lg" value={novoFuncionario.r2_agrup} onChange={e => setNovoFuncionario({...novoFuncionario, r2_agrup: e.target.value})}>{agrupamentos.map(a => <option key={a}>{a}</option>)}</select>
                        <select className="text-[11px] p-2 bg-slate-50 border-none rounded-lg font-bold" value={novoFuncionario.r2_enq || ""} onChange={e => setNovoFuncionario({...novoFuncionario, r2_enq: e.target.value === "" ? null : parseInt(e.target.value)})}>
                           {enquadramentos.map(enq => <option key={String(enq.value)} value={enq.value === null ? "" : enq.value}>{enq.label}</option>)}
                        </select>
                    </div>
                    <select className="w-full text-[11px] p-2 bg-purple-50 text-purple-700 border-none rounded-lg font-bold" value={novoFuncionario.r2_mes} onChange={e => setNovoFuncionario({...novoFuncionario, r2_mes: e.target.value})}>
                        {mesesNome.map((m, idx) => (
                          <option key={m} value={m} disabled={idx < MES_ATUAL_IDX}>{m}{idx < MES_ATUAL_IDX ? ' ✕' : ''}</option>
                        ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>

            <div className="px-8 py-6 bg-slate-50 flex gap-4 border-t">
              <button type="button" onClick={() => setmostrarModalFuncionario(false)} className="px-8 py-3 text-slate-500 font-bold hover:bg-slate-200 rounded-2xl transition-all">Cancelar</button>
              <button type="submit" className="flex-1 py-3 bg-gradient-to-r from-indigo-700 to-purple-700 text-white font-bold rounded-2xl shadow-xl shadow-indigo-200 hover:brightness-110 transition-all flex items-center justify-center gap-2">
                <Plus className="w-5 h-5" /> Adicionar e Projetar Folha
              </button>
            </div>
          </form>
        </div>
      )}
      {mostrarModalDetalhamento && (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm">
          <div className="bg-zinc-900 border border-white/10 rounded-xl w-full max-w-7xl max-h-[80vh] overflow-hidden flex flex-col shadow-2xl">
            
            {/* Header */}
            <div className="p-6 border-b border-white/10 flex justify-between items-center bg-zinc-800/50">
              <div>
                <h2 className="text-xl font-bold text-white">Detalhamento de Reajuste</h2>
                <p className="text-zinc-400 text-sm">Valores baseados no enquadramento e agrupamento percentual</p>
              </div>
            </div>

            {/* Tabela com Scroll Horizontal */}
            <div className="p-6 overflow-auto">
              <div className="inline-block min-w-full align-middle border border-white/5 rounded-lg">
                <table className="min-w-full divide-y divide-white/10 text-sm">
                  <thead className="bg-white/5">
                    <tr>
                      <th className="px-4 py-3 text-left font-bold text-zinc-300">Enquadr.</th>
                      {columns.map((col) => (
                        <th key={col} className="px-4 py-3 text-center font-bold text-zinc-300">
                          {col}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-white/5 bg-transparent">
                    {rows.map((rowIndex) => (
                      <tr key={rowIndex} className="hover:bg-white/5 transition-colors">
                        <td className="px-4 py-3 font-medium text-zinc-400 border-r border-white/5">
                          {rowIndex}
                        </td>
                        {columns.map((col) => (
                          <td key={`${col}-${rowIndex}`} className="px-4 py-3 text-right text-zinc-300 whitespace-nowrap">
                           {formatCurrency(TABELA_REAJUSTE[col][rowIndex])}
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            {/* Footer */}
            <div className="p-4 border-t border-white/10 text-center bg-zinc-800/30">
              <button 
                onClick={() => setmostrarModalDetalhamento(false)}
                className="text-sm text-zinc-400 hover:text-white underline"
              >
                Fechar Visualização
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SimuladorDefinitivo;